const localeUtils = require('utils/LanguageLocale');

let getConstants = () => {
    const getText = localeUtils.getLocaleResourceFile(
        'constants/locales',
        'Constants'
    );

    return {
        CANADA_LEGAL_COPY: getText('canadaLegalCopy'),
        PROP_65_MSG: getText('prop65Msg'),
        BUTTON_TEXT: {
            COMING_SOON: getText('comingSoon'),
            AVAILABLE_IN_STORE_ONLY: getText('availableInStoreOnly'),
            SOLD_OUT: getText('soldOut'),
            OUT_OF_STOCK: getText('outOfStock'),
            OOS_ACTIVE: getText('emailWhenInStock'),
            OOS_INACTIVE: getText('removeReminder')
        },
        SEPHORA_URL: {
            DESKTOP: 'https://www.sephora.com'
        },
        AVATAR_DEFAULT: 'https://community.sephora.com/t5/image/serverpage/avatar-name/default-avatar/avatar-theme/sephora/avatar-collection/sephora/avatar-display-size/profile/version/4'
    };
};

module.exports = getConstants();
